import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Picker } from 'antd-mobile';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

const FormSelect = ({ name, formData, optionValueList, changeInputHandle }) => {
    const [selectValue, setSelectValue] = useState('');
    const [visible, setVisible] = useState(false);

    const changeHandle = (value) => {
        setSelectValue(value);
        changeInputHandle(name, value);
    };

    const pickerList = optionValueList.map((item) => {
        return {
            label: item,
            value: item,
        };
    });
    const defaultValue = formData?.[name] || selectValue || '';

    return (
        <div className={styles.formInputBox}>
            <div
                onClick={() => {
                    setVisible(true);
                }}>
                <div className={`${styles.formSelect} ${defaultValue !== '' ? styles.active : ''}`}>{defaultValue || '未选择'}</div>
            </div>
            <Picker
                defaultValue={[defaultValue]}
                columns={[pickerList]}
                visible={visible}
                onConfirm={(value) => {
                    changeHandle(value?.[0] || '');
                }}
                onClose={() => {
                    setVisible(false);
                }}
            />
        </div>
    );
};

FormSelect.propTypes = {
    name: PropTypes.string,
    formData: PropTypes.object,
    changeInputHandle: PropTypes.func,
    optionValueList: PropTypes.array,
};

export default errorBoundary(FormSelect);
